import { Link } from "react-router-dom";
import logo from "../assets/Burgersson-Logo-footer.png";
const Footer = () => {
  const navLinks = [
    { label: "Lunch", link: "/lunch" },
    { label: "Takeaway", link: "/takeaway" },
    { label: "Större Sällskap", link: "/events" },
    { label: "Kontakta Oss", link: "/contact" },
  ];
  const socialLinks = ["Instagram", "Facebook", "X"];

  return (
    <footer className="bg-background border-t border-border py-16 px-6 md:px-16">
      <div className="max-w-full grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* First div — 2 cols */}
        <div className="md:col-span-2">
          <img src={logo} alt="Burgersson" className="w-[500px]" />
          <p className="font-body text-xs text-muted-foreground tracking-wide uppercase leading-relaxed">
            SKANSTORGET 4, 411 22 GöTEBORG <br />
          </p>
        </div>

        {/* Second div — 1 col */}
        <div className="flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.link}
              className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {link.label.toUpperCase()}
            </Link>
          ))}
        </div>

        {/* Third div — 1 col */}
        <div className="flex flex-col gap-3">
          {socialLinks.map((social) => (
            <Link
              key={social}
              to="#"
              className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {social.toUpperCase()}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
